import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "h-inner" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "h-right" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "btn-refresh-count" }
const _hoisted_7 = {
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"opacity":".7"}
}
const _hoisted_8 = {
  key: 0,
  class: "docs-menu"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 0,
  class: "btn-myteam-badge"
}
const _hoisted_13 = {
  key: 2,
  class: "hf-wrap"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "btn-refresh-count"
}
const _hoisted_16 = {
  key: 3,
  class: "h-user"
}
const _hoisted_17 = { class: "h-user-avatar" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "h-user-info" }
const _hoisted_20 = { class: "h-user-name" }
const _hoisted_21 = { class: "h-user-role" }
const _hoisted_22 = {
  key: 0,
  class: "h-atend-badge"
}
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  width: "8",
  height: "8",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"opacity":".7"}
}
const _hoisted_25 = {
  key: 0,
  class: "h-avail-menu"
}
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = {
  key: 0,
  class: "h-avail-error"
}
const _hoisted_28 = {
  key: 0,
  class: "h-avail-success"
}
const _hoisted_29 = { class: "topbar" }
const _hoisted_30 = { class: "topbar-inner" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import type { AuthUser } from '@/types/auth'
import { useTheme } from '@/composables/useTheme'
import { useAdmin } from '@/composables/useAdmin'
import { usePermission } from '@/composables/usePermission'
import { availStatus, updateAvailability, AVAIL_OPTIONS, syncAvailStatus } from '@/composables/useAvailability'
import { useLogo } from '@/composables/useLogo'
import { secondsUntilWarning, showWarning, triggerTestWarning } from '@/composables/useAutoLogout'
import { hiddenFluxoIds, setHiddenFluxoIds } from '@/composables/useHiddenFluxos'
import { FLUXO_MAP } from '@/composables/useHelpers'
import { roleFilteredConversations } from '@/composables/useDashboardEngine'
import MultiSelectFilter from '@/components/dashboard/MultiSelectFilter.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashHeader',
  props: {
    loading: { type: Boolean },
    lastUpdate: {},
    countdown: {},
    user: {},
    myCount: {},
    myOpenCount: {},
    myTeamFilter: { type: Boolean },
    myFluxosFilter: { type: Boolean }
  },
  emits: ["export", "logout", "testNotif", "toggleMyTeamFilter", "toggleMyFluxosFilter"],
  setup(__props: any) {

const { logoUrl } = useLogo()

const props = __props



// Botão "Atualizar": força reload equivalente a Ctrl+F5 (limpa cache do SW e
// do browser antes de recarregar), em vez de só re-buscar dados via API.
async function hardRefresh() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } finally {
    window.location.reload()
  }
}

const { darkMode, toggleTheme } = useTheme()
const { profiles } = useAdmin()
const { can } = usePermission()
const canHideFluxo = computed(() => can('dashboard.hideFluxo'))
const fluxoHideOptions = computed(() => Object.entries(FLUXO_MAP).map(([id, name]) => ({
  id:    Number(id),
  name,
  count: roleFilteredConversations.value.filter(c => c.fluxo_id === Number(id)).length,
})))
const hiddenFluxoModel = computed({
  get: () => hiddenFluxoIds.value,
  set: (v: Array<number | string>) => setHiddenFluxoIds(v.map(Number)),
})
const avatarError    = ref(false)
const showTestBtn    = ref(false)
const showAutoLogoutTestBtn = ref(false)
const showAvailMenu  = ref(false)
const changingAvail  = ref(false)
const availWrap      = ref<HTMLElement | null>(null)
const availError     = ref('')
const availSuccess   = ref('')
const showDocsMenu   = ref(false)
const docsWrap       = ref<HTMLElement | null>(null)

const availLabelHeader = computed(() => {
  const map: Record<string, string> = { online: 'Online', busy: 'Ocupado', offline: 'Offline' }
  return map[availStatus.value] ?? availStatus.value
})

async function changeAvail(status: string) {
  if (!props.user?.access_token) {
    availError.value = 'Sem token de acesso'
    setTimeout(() => { availError.value = '' }, 5000)
    return
  }
  showAvailMenu.value = false
  changingAvail.value = true
  availError.value   = ''
  availSuccess.value = ''
  try {
    await updateAvailability(props.user.access_token, status as any, props.user.id)
    availSuccess.value = 'Status atualizado!'
    setTimeout(() => { availSuccess.value = '' }, 3000)
  } catch (e: any) {
    console.error('[DashHeader] Erro ao atualizar disponibilidade:', e)
    availError.value = e?.message || 'Erro ao atualizar'
    setTimeout(() => { availError.value = '' }, 8000)
  }
  changingAvail.value = false
}

function onDocClick(e: MouseEvent) {
  if (availWrap.value && !availWrap.value.contains(e.target as Node)) {
    showAvailMenu.value = false
  }
  if (docsWrap.value && !docsWrap.value.contains(e.target as Node)) {
    showDocsMenu.value = false
  }
}

function openDoc(file: string) {
  window.open(`/docs/${file}`, '_blank')
  showDocsMenu.value = false
}

function onKeyDown(e: KeyboardEvent) {
  // Ignora se o foco estiver em input/textarea
  const tag = (e.target as HTMLElement)?.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA') return
  if (e.key === '&') showTestBtn.value = !showTestBtn.value
  if (e.ctrlKey && e.key === '*') {
    e.preventDefault()
    showAutoLogoutTestBtn.value = !showAutoLogoutTestBtn.value
  }
}

// "Ativo!" enquanto o modal/toast já está em tela; senão mm:ss até disparar
// sozinho (null = auto-logout desativado ou rota isenta — sem contagem).
const autoLogoutCountdownLabel = computed(() => {
  if (showWarning.value) return 'Ativo!'
  if (secondsUntilWarning.value === null) return 'desativado'
  const total = secondsUntilWarning.value
  const mm = Math.floor(total / 60)
  const ss = total % 60
  return `${mm}:${String(ss).padStart(2, '0')}`
})

onMounted(async () => {
  document.addEventListener('keydown', onKeyDown)
  document.addEventListener('click', onDocClick)
  // Sincroniza disponibilidade real do usuário logado (limpa localStorage de sessão anterior)
  if (props.user?.access_token) {
    try {
      const res = await fetch('/chatwoot-api/api/v1/profile', {
        headers: { api_access_token: props.user.access_token },
      })
      if (res.ok) {
        const profile = await res.json()
        const account = profile.accounts?.find((a: any) => a.id === 3)
        // Prefere `availability` (o que o próprio agente define no dropdown) sobre
        // `availability_status` (presença computada pelo Chatwoot via ActionCable/
        // auto_offline, que fica "offline" pra quem só acessa via esta dashboard).
        const status = account?.availability || account?.availability_status || profile.availability_status || 'offline'
        syncAvailStatus(status)
      }
    } catch { /* silent */ }
  }
})
onUnmounted(() => {
  document.removeEventListener('keydown', onKeyDown)
  document.removeEventListener('click', onDocClick)
})

const initials = computed(() => {
  if (!props.user?.name) return ''
  return props.user.name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
})

const currentProfile = computed(() => {
  if (!props.user) return null
  return profiles.value.find(p => p.userIds.includes(props.user!.id)) ?? null
})

const roleLabel = computed(() => {
  if (!props.user) return ''
  if (currentProfile.value) return currentProfile.value.name
  return props.user.role === 'administrator' ? 'Administrador' : 'Agente'
})

// Perfil "EC - ISBET" (fallback) não tem time próprio no Chatwoot — troca o
// filtro "Meu Time" por "Meus Fluxos" (ver DashboardView.vue → myFluxosFilter).
const isEcIsbet = computed(() => currentProfile.value?.name === 'EC - ISBET')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logoUrl),
            alt: "ISBET",
            style: {"height":"100px","object-fit":"contain"}
          }, null, 8, _hoisted_3),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "logo-text" }, [
            _createElementVNode("div", { class: "logo-sub" }, "Wootdash")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "live-badge" }, [
            _createElementVNode("div", { class: "live-dot" }),
            _createTextVNode(" Ao vivo ")
          ], -1)),
          _withDirectives(_createElementVNode("button", {
            class: "btn-notif-test",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('testNotif'))),
            title: "Testar notificação (& para esconder)"
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
              _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
            ], -1),
            _createElementVNode("span", null, "Testar Notif.", -1)
          ]))], 512), [
            [_vShow, showTestBtn.value]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "btn-notif-test",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(triggerTestWarning) && _unref(triggerTestWarning)(...args)), ["stop"])),
            title: `Testar aviso de inatividade (Ctrl+Shift+* para esconder) — ${autoLogoutCountdownLabel.value}`
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
            ], -1)),
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "Testar Inatividade", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(autoLogoutCountdownLabel.value), 1)
          ], 8, _hoisted_5), [
            [_vShow, showAutoLogoutTestBtn.value]
          ]),
          _createElementVNode("button", {
            class: "btn-export",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('export')))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
              _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
              _createElementVNode("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "3"
              })
            ], -1),
            _createElementVNode("span", null, "Exportar", -1)
          ]))]),
          _createElementVNode("div", {
            class: "docs-wrap",
            ref_key: "docsWrap",
            ref: docsWrap
          }, [
            _createElementVNode("button", {
              class: "btn-docs",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showDocsMenu.value = !showDocsMenu.value), ["stop"])),
              title: "Abrir documentação"
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }),
                _createElementVNode("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" })
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("span", null, "Docs", -1)),
              (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
              ]))]))
            ]),
            _createVNode(_Transition, { name: "avail-menu" }, {
              default: _withCtx(() => [
                (showDocsMenu.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "docs-opt",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (openDoc('dashboard-documentacao.html')))
                      }, [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }),
                          _createElementVNode("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" })
                        ], -1),
                        _createTextVNode(" Documentação ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "docs-opt",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (openDoc('guia-do-usuario.html')))
                      }, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }),
                          _createElementVNode("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4" }),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "17",
                            x2: "12.01",
                            y2: "17"
                          })
                        ], -1),
                        _createTextVNode(" Guia do Usuário ", -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 512),
          _createElementVNode("button", {
            class: "btn-theme",
            title: _unref(darkMode) ? 'Mudar para tema claro' : 'Mudar para tema escuro',
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
          }, [
            (!_unref(darkMode))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[23] || (_cache[23] = [
                  _createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"5\" data-v-eea8c388></circle><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\" data-v-eea8c388></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\" data-v-eea8c388></line><line x1=\"4.22\" y1=\"4.22\" x2=\"5.64\" y2=\"5.64\" data-v-eea8c388></line><line x1=\"18.36\" y1=\"18.36\" x2=\"19.78\" y2=\"19.78\" data-v-eea8c388></line><line x1=\"1\" y1=\"12\" x2=\"3\" y2=\"12\" data-v-eea8c388></line><line x1=\"21\" y1=\"12\" x2=\"23\" y2=\"12\" data-v-eea8c388></line><line x1=\"4.22\" y1=\"19.78\" x2=\"5.64\" y2=\"18.36\" data-v-eea8c388></line><line x1=\"18.36\" y1=\"5.64\" x2=\"19.78\" y2=\"4.22\" data-v-eea8c388></line>", 9)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" }, null, -1)
                ]))]))
          ], 8, _hoisted_9),
          (!isEcIsbet.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn-myteam", { active: __props.myTeamFilter }]),
                title: "Filtrar minhas conversas",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('toggleMyTeamFilter')))
              }, [
                _cache[25] || (_cache[25] = _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "7",
                    r: "4"
                  })
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "Meu Time", -1)),
                (__props.myCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(__props.myCount), 1))
                  : _createCommentVNode("", true)
              ], 2))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn-myteam", { active: __props.myFluxosFilter }]),
                title: "Filtrar conversas só dos meus fluxos",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('toggleMyFluxosFilter')))
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" })
                ], -1),
                _createElementVNode("span", null, "Meus Fluxos", -1)
              ]))], 2)),
          (canHideFluxo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(MultiSelectFilter, {
                  options: fluxoHideOptions.value,
                  modelValue: hiddenFluxoModel.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((hiddenFluxoModel).value = $event)),
                  placeholder: "Esconder Fluxo"
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-refresh", { spinning: __props.loading }]),
            title: `Auto-atualização em ${__props.countdown}s`,
            onClick: hardRefresh
          }, [
            _cache[28] || (_cache[28] = _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "23 4 23 10 17 10" }),
              _createElementVNode("polyline", { points: "1 20 1 14 7 14" }),
              _createElementVNode("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" })
            ], -1)),
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Atualizar", -1)),
            (!__props.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(__props.countdown) + "s", 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_14),
          (__props.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: "/profile",
                  class: "h-user-link",
                  title: "Meu perfil"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      (__props.user.avatar_url)
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: __props.user.avatar_url,
                            alt: __props.user.name,
                            class: "h-avatar-img",
                            onError: _cache[10] || (_cache[10] = ($event: any) => (avatarError.value = true))
                          }, null, 40, _hoisted_18)), [
                            [_vShow, !avatarError.value]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["h-avatar-initials", { hidden: __props.user.avatar_url && !avatarError.value }])
                      }, _toDisplayString(initials.value), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["h-avail-badge", `h-avail-badge--${_unref(availStatus)}`])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(__props.user.name), 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(roleLabel.value), 1),
                      (__props.myOpenCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                              _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                            ], -1),
                            _createTextVNode(" em atendimento ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "h-avail-wrap",
                  ref_key: "availWrap",
                  ref: availWrap
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["h-avail-trigger", `h-avail-trigger--${_unref(availStatus)}`]),
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (showAvailMenu.value = !showAvailMenu.value), ["stop"])),
                    title: `Disponibilidade: ${availLabelHeader.value}`
                  }, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "h-avail-dot" }, null, -1)),
                    (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                    ]))]))
                  ], 10, _hoisted_23),
                  _createVNode(_Transition, { name: "avail-menu" }, {
                    default: _withCtx(() => [
                      (showAvailMenu.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AVAIL_OPTIONS), (opt) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: opt.value,
                                class: _normalizeClass(["h-avail-opt", { 'h-avail-opt--active': _unref(availStatus) === opt.value }]),
                                onClick: ($event: any) => (changeAvail(opt.value)),
                                disabled: changingAvail.value
                              }, [
                                _createElementVNode("span", {
                                  class: "h-avail-opt-dot",
                                  style: _normalizeStyle({ background: opt.color })
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(opt.label), 1)
                              ], 10, _hoisted_26))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 512),
                _createVNode(_Transition, { name: "avail-err" }, {
                  default: _withCtx(() => [
                    (availError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(availError.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "avail-err" }, {
                  default: _withCtx(() => [
                    (availSuccess.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(availSuccess.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "btn-logout",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('logout'))),
                  title: "Sair"
                }, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
                    _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
                    _createElementVNode("line", {
                      x1: "21",
                      y1: "12",
                      x2: "9",
                      y2: "12"
                    })
                  ], -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _cache[36] || (_cache[36] = _createElementVNode("span", null, [
          _createTextVNode("Wootdash "),
          _createElementVNode("strong", null, "CRM"),
          _createTextVNode(" — Conversas em tempo real")
        ], -1)),
        _createElementVNode("span", null, [
          _cache[35] || (_cache[35] = _createTextVNode("Atualizado: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.lastUpdate || '—'), 1)
        ])
      ])
    ])
  ], 64))
}
}

})